import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "py-3 container-fluid" }
const _hoisted_2 = { class: "bg-white rounded-xl shadow-md p-3 space-y-2" }
const _hoisted_3 = { class: "text-base font-bold text-gray-600 mb-3" }
const _hoisted_4 = { class: "w-full flex flex-col lg:flex-row gap-2" }
const _hoisted_5 = { class: "w-full flex flex-col" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex flex-wrap -mx-1" }
const _hoisted_8 = { class: "w-full flex flex-col lg:flex-row gap-1 pb-4 text-center" }
const _hoisted_9 = { class: "bg-transparent p-0" }
const _hoisted_10 = { class: "w-full flex flex-col" }
const _hoisted_11 = { class: "w-full flex flex-row items-center justify-center px-5 py-5 text-2xl font-semibold text-center text-gray-500" }
const _hoisted_12 = { class: "flex flex-wrap flex-1 -mx-1 mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ItemEmpresaView = _resolveComponent("ItemEmpresaView")!
  const _component_ItemAcreditadoView = _resolveComponent("ItemAcreditadoView")!
  const _component_DataView = _resolveComponent("DataView")!
  const _component_FullScreenLoader = _resolveComponent("FullScreenLoader")!
  const _component_PedirCitaView = _resolveComponent("PedirCitaView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('label.filtros')), 1),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.configuracionMeeting.tipoVistaSolicitudes == _ctx.VISTA_MEETING_EMPRESA)
            ? (_openBlock(), _createBlock(_component_Field, {
                key: 0,
                name: "filtroPais",
                modelValue: _ctx.filtroPais,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtroPais) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                  _createVNode(_component_Select, {
                    onBlur: handleBlur,
                    filter: "",
                    "onUpdate:modelValue": val => { handleChange(val);  _ctx.filtroPais = val; _ctx.filtrar(); },
                    "show-clear": "",
                    "model-value": value,
                    placeholder: _ctx.$t('label.pais'),
                    class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                    options: _ctx.paises,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "placeholder", "options", "class"])
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.configuracionMeeting.tipoVistaSolicitudes == _ctx.VISTA_MEETING_ACREDITADO)
            ? (_openBlock(), _createBlock(_component_Field, {
                key: 1,
                name: "filtroTipoAcreditado",
                modelValue: _ctx.filtroTipoAcreditado,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtroTipoAcreditado) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                  _createVNode(_component_Select, {
                    onBlur: handleBlur,
                    filter: "",
                    "onUpdate:modelValue": val => { handleChange(val);  _ctx.filtroTipoAcreditado = val; _ctx.filtrar(); },
                    "show-clear": "",
                    "model-value": value,
                    placeholder: _ctx.$t('label.tipo.acreditado'),
                    class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                    options: _ctx.tiposAcreditados,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "placeholder", "options", "class"])
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createVNode(_component_InputText, {
            onKeyup: _ctx.filtrar,
            modelValue: _ctx.filtroTexto,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filtroTexto) = $event)),
            placeholder: _ctx.$t('label.buscar'),
            class: "input-base"
          }, null, 8, ["onKeyup", "modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.tags)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tag.id,
                      class: "w-full md:w-1/2 lg:w-1/4 px-1 pb-2"
                    }, [
                      _createVNode(_component_Field, {
                        name: `tag-${tag.id}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MultiSelect, {
                            "model-value": tag.opcionesTagSeleccionados,
                            "show-clear": "",
                            "onUpdate:modelValue": val => { tag.opcionesTagSeleccionados = val; _ctx.filtrar(); },
                            options: tag.opciones,
                            optionLabel: "descripcion",
                            optionValue: "id",
                            filter: "",
                            placeholder: tag.descripcion,
                            class: "input-base"
                          }, null, 8, ["model-value", "onUpdate:modelValue", "options", "placeholder"])
                        ]),
                        _: 2
                      }, 1032, ["name"])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("a", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.limpiarFiltros && _ctx.limpiarFiltros(...args))),
            class: "cursor-pointer px-6 text-sm font-bold text-red-500 bg-transparent py-2 border border-red-500 shadow-md rounded-xl transform transition-transform duration-200 hover:scale-[102%] active:scale-95"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-trash'] }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.limpiar.filtros')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_DataView, {
            value: _ctx.itemsMeetingFiltrados,
            paginator: "",
            rows: 20,
            alwaysShowPaginator: false,
            dataKey: "item.id",
            class: "!bg-transparent"
          }, {
            empty: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('label.no.hay.datos')), 1)
            ]),
            list: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "w-full p-1.5 md:w-6/12 lg:w-3/12 flex flex-col"
                  }, [
                    (item.tipo == _ctx.VISTA_MEETING_EMPRESA)
                      ? (_openBlock(), _createBlock(_component_ItemEmpresaView, {
                          key: 0,
                          itemMeeting: item,
                          onSolicitarReunion: _ctx.onSolicitarReunion,
                          permiteSolicitarReuniones: _ctx.permiteSolicitarReuniones
                        }, null, 8, ["itemMeeting", "onSolicitarReunion", "permiteSolicitarReuniones"]))
                      : _createCommentVNode("", true),
                    (item.tipo == _ctx.VISTA_MEETING_ACREDITADO)
                      ? (_openBlock(), _createBlock(_component_ItemAcreditadoView, {
                          key: 1,
                          itemMeeting: item,
                          onSolicitarReunion: _ctx.onSolicitarReunion,
                          permiteSolicitarReuniones: _ctx.permiteSolicitarReuniones
                        }, null, 8, ["itemMeeting", "onSolicitarReunion", "permiteSolicitarReuniones"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ])
    ]),
    _createVNode(_component_FullScreenLoader, { visible: _ctx.isSubmitting }, null, 8, ["visible"]),
    (_ctx.pedirCitaVisible)
      ? (_openBlock(), _createBlock(_component_PedirCitaView, {
          key: 0,
          closeFunction: _ctx.closeDialogPedirCita,
          itemMeetingSeleccionado: _ctx.itemMeetingSeleccionado
        }, null, 8, ["closeFunction", "itemMeetingSeleccionado"]))
      : _createCommentVNode("", true)
  ], 64))
}